import React from 'react';
import {
  SinglePageHeader,
  FooterWithoutAuth,
  BlogCard,
  Layout,
} from 'components';
import './packages-and-payment-page.less';

import './blog.less';
import marketingImg from 'assests/images/kobiler-icin-sms.jpg';
import blogBannerAccessory1 from 'assests/images/pap-accessory-1.png';
import blogBannerAccessory2 from 'assests/images/features-accessory-3.png';
import { LANDING_MENU } from 'constants/page.const';
import { MetaTags } from 'react-meta-tags';

const KobiBlogPage = () => {
  return (
    <Layout
      hamburgerMenuWithButton={true}
      hamburgerMenuData={LANDING_MENU}
      hamburgerMenuClass="single-page-v1"
      withoutHeaderDropdown={true}
      withoutCreditInfo={true}
      menuSinglePageV2={true}
      customMenuRender={() => <SinglePageHeader />}
    >
      <MetaTags>
        <title>
        KOBİ'ler İçin Toplu SMS Servisi | Mesaj Üssü
        </title>
        <meta
          name="description"
          content="KOBİ'lerin toplu SMS gönderimleri ile elde edebilecekleri faydaları, KOBİ'lere özel toplu SMS kullanımını ve diğer detayları bu blog yazısında bulabilirsiniz."
        />
        <link
          rel="canonical"
          href="https://mesajussu.turkcell.com.tr/kobiler-icin-toplu-sms"
        />
      </MetaTags>
      <div className="blog-page blog-page--marketing">
        <div className="blog-banner">
          <div className="container">
            <div>
              <h1 className="section__title--big">
              KOBİ'ler İçin Toplu SMS Hizmeti
              </h1>
              <p className="info-text--big">
              KOBİ'lerin toplu SMS gönderimleri ile elde edebilecekleri faydaları,
               KOBİ'lere özel toplu SMS kullanımını ve diğer detayları bu blog yazısında bulabilirsiniz.
              </p>
            </div>
            <figure>
            <a href="/toplu-sms">
              <img src={marketingImg} alt="KOBİ'ler İçin Toplu SMS Hizmeti" />
            </a>
            </figure>
          </div>
          <img
            id="blog-banner-accessory-1"
            src={blogBannerAccessory1}
            alt="KOBİ'ler İçin Toplu SMS Hizmeti 2"
          />
          <img
            id="blog-banner-accessory-2"
            src={blogBannerAccessory2}
            alt="KOBİ'ler İçin Toplu SMS Hizmeti 3"
          />
        </div>
        <div className="blogs-wrapper">
          <div className="container">
            <ul>
              <li>
              <p>Küçük ve orta büyüklükte bir işletme sahibiyseniz, işlerinizi büyütmek ve daha fazla müşteri
              potansiyeline ulaşmak için başvurabileceğiniz çok sayıda yöntem bulunur. Mesaj Üssü tarafından size
              sunulan
              toplu SMS hizmeti, bu avantajlardan yalnızca biri! Turkcell Mesaj Üssü KOBİ toplu SMS hizmeti ile
              bölgenizdeki ya da daha geniş bir portföydeki pek çok müşteri adayına işletmenizin kampanyalarını,
              fırsatlarını ve avantajlarını kolayca duyurabilir ve böylece tek seferde çok sayıda kişiye kolayca
              ulaşabilirsiniz. Çoklu mesajlaşma avantajı sayesinde eski müşterilerinizi de geri kazanabilir ve
              KOBİ'nizin iş potansiyeline rahatça ulaşabilirsiniz.</p>
              </li>
              <li>
                <h2>Toplu SMS Gönderme Hizmeti ile Tanışın</h2>
                <p>Toplu mesajlaşma, pek çok ticari kuruluşun en önemli reklam yöntemleri arasında ilk sıralarda yer alır.
              Hedef kitleye doğrudan ulaşma imkânı sağlayan ve potansiyel müşterilerinize işletmenizin avantajlarını
              kolayca aktarabilmenizi mümkün hâle getiren toplu SMS mikro işletmeler için de son derece uygun bir
              tanıtım yöntemidir. Toplu SMS gönderme, ağırlıklı olarak enterprise firmalara ve büyük çaplı şirketlere
              uygun bir yöntem olarak görülse de esasında bu yöntem küçük ve orta büyüklükteki işletmeler için de son
              derece idealdir. Özellikle daha önce sizden alışveriş yapmış kişilere, bölgenizde yaşayan potansiyel
              müşterilere ve verdiğiniz hizmeti arayan kişilere doğrudan ulaşabilmenizi sağlamaları sebebiyle iş
              hacminize direkt katkı sunan toplu SMS sistemi, Turkcell Mesaj Üssü tarafından size sunulan imkânlarla
              rahatlıkla gerçekleştirilebilir. Mikro işletmeler için toplu SMS gönderiminde bulunmak için Turkcell'in
              “Toplu SMS yolla” hizmetinden yararlanmanız yeterlidir. Hizmetten yararlanmak için ise KOBİ'niz adına
              şirket hattı sahibi olmanız ve Turkcell Mesaj Üssü ile iletişim kurmanız gerekir.</p>

              </li>
              <li>
                <h2>Orta Ölçekli İşletmeler için Toplu SMS Avantajlarından Yararlanın</h2>
                <p>Orta ölçekli işletmeler için toplu SMS hizmeti, işletmenizin daha geniş bir hedef kitleye kolayca
              ulaşmasını sağlamanın en pratik yollarından biridir. Çoklu mesaj gönderme hizmeti, işletmenizin en güncel
              kampanyalarını, fiyatlarını ve avantajlarını müşteri adaylarınızla sadece saniyeler içinde
              paylaşabilmenize olanak tanır. Her türlü reklam faaliyetinden çok daha düşük bütçelerle
              gerçekleştirilebilen çoklu SMS faaliyetleri, tanıtım için yüksek bütçeler ayırmak istemeyen küçük ve orta
              büyüklükteki işletmeler için de son derece idealdir. Toplu SMS aktiviteleri; sezonluk, dönemlik ya da
              günlük kampanyalarınızı tanıtmanız için de en uygun iletişim yöntemlerinden biridir. Pek çok reklam ve
              tanıtım yönteminde potansiyel müşterilerinize ulaşmanız, belirli bir zaman alabilir ve bu durum da kısa
              süreli kampanyaların beklenen ilgiyi görememesine yol açabilir. Toplu mesaj yöntemi ise müşterilerinize
              hızla ulaşabilmenizi sağlar ve böylece haftalık, günlük ve hatta saatlik kampanyalarınızın bile yüksek
              ilgi görmesine yardımcı olur. Kurumsal SMS hizmeti, aynı zamanda işletmenizdeki değişimleri duyurmanız
              için de uygun bir yöntemdir. Adres, fiyat, çalışma saati gibi konularda yaşanan değişiklikleri Kobilere
              özel toplu SMS servisi sayesinde kısa sürede duyurabilir ve böylece değişiklik nedeniyle müşteri kaybetme
              riskinden kurtulabilirsiniz. Toplu SMS hizmeti sayesinde ayrıca;</p>

            <ul>
              <li>Mesajlarınızın geri dönüşlerini raporlayabilir,</li>
              <li>Mesajlarınızın geri dönüşlerini raporlayabilir,</li>
              <li>Kendi müşteri portföyünüzden yararlanabilir,</li>
              <li>Abonelere özel ayrı mesaj içerikleri oluşturabilir,</li>
              <li>Herhangi bir altyapı kurulumu olmaksızın maksimum müşteri sayısına ulaşabilirsiniz.</li>
            </ul>
              </li>
              <li>
                <h2>
                Mesaj Üssü Kobiler için Toplu SMS Hizmetinden Nasıl Faydalanılır?
                </h2>
                <p>Turkcell Mesaj Üssü, kobiler için özel olarak başlıklı SMS gönderme hizmetini üç farklı şekilde sunar. Ön
              ödemeli Dijital Mesajlaşma Servisi'ni faturasız hatlarda kullanabilir ve önden yaptığınız ödeme miktarınca
              başlıklı SMS atabilirsiniz. Taahhütsüz DMS paketlerinde yolladığınız SMS kadar ödeme yapar, Taahhütlü DMS
              paketlerinde ise verdiğiniz taahhüt süresi boyunca paketinizdeki tüm SMS haklarınızı toplu SMS programı
              aracılığıyla müşterilerinizi bilgilendirmek amacıyla kullanabilirsiniz. Eğer siz de KOBİ'nizin iş hacmini
              zirveye ulaştırmak istiyorsanız, hemen Turkcell Mesaj Üssü toplu SMS gönderme avantajlarından
              yararlanabilir ve işletmenizin tanıtımını son derece cazip fiyatlarla kolayca gerçekleştirebilirsiniz.</p>
              
              </li>
            </ul>
          </div>
        </div>
      </div>
      <FooterWithoutAuth />
    </Layout>
  );
};

export default KobiBlogPage;
